/**
 *   Copyright (C) Cylergie - All Rights Reserved
 * Proprietary and confidential
 * Subject to French law on copyright
 * Unauthorized copying of this file, via any medium is strictly prohibited: https://crigen.myengie.com/copyright
 * Any request for authorization of use should be addressed by email to“mvalo.bvt@engie.com” with the subject “Copyright Statement in Source Code”
 * Written in 2024
 */

import store from '../store/index';

export default {
  setupCheckBoxes(step) {
    switch (step) {
      case 1:
        store.commit('CHECK_ID', true);
        store.commit('CHECK_SITE', false);
        store.commit('CHECK_BOILER', false);
        break;
      case 2:
        store.commit('CHECK_ID', true);
        store.commit('CHECK_SITE', true);
        store.commit('CHECK_BOILER', false);
        break;
      case 3:
        store.commit('CHECK_ID', true);
        store.commit('CHECK_SITE', true);
        store.commit('CHECK_BOILER', true);
        break;
      default:
        store.commit('CHECK_ID', false);
        store.commit('CHECK_SITE', false);
        store.commit('CHECK_BOILER', false);
        break;
    }
  },
};
